// extracted by mini-css-extract-plugin
export default {"page-section":"PageSection_page-section__PW4Yd"};